import { ReactNode, useEffect, useState } from 'react';

import ActivityBuilderComponentPreview from './activity-builder-component-preview';
import { ComponentHiddenSizeRenderPreview } from './activity-builder-component-preview.style';
import { ACTIVITY_SHEET_CONTENT_MAX_WIDTH } from '../components/shared/sheet/activity-sheet.style';

const ActivityBuilderComponentMeasuredPreview = ({
  id,
  component,
  width = ACTIVITY_SHEET_CONTENT_MAX_WIDTH,
}: {
  component: ReactNode;
  id: number | string;
  width?: number;
}) => {
  const [dimensions, setDimensions] = useState<{
    width: number;
    height: number;
  }>({
    width: 0,
    height: 0,
  });

  useEffect(() => {
    const tAnswer = document.getElementById(`hidden-${id}`);
    if (tAnswer) {
      setDimensions({
        width: tAnswer.offsetWidth,
        height: tAnswer.offsetHeight + 24, // 24px is the margin bottom to next component
      });
    }
  }, [id]);

  return (
    <>
      <ComponentHiddenSizeRenderPreview id={`hidden-${id}`} $width={width}>
        {component}
      </ComponentHiddenSizeRenderPreview>
      <ActivityBuilderComponentPreview content={dimensions}>
        {component}
      </ActivityBuilderComponentPreview>
    </>
  );
};

export default ActivityBuilderComponentMeasuredPreview;
